import { Notify } from 'notiflix/build/notiflix-notify-aio';

import {
  setFeaturesMonitoring,
  setFeaturesVpsFree,
  setFeaturesVpsPaid,
} from '@/redux/features/featuresSlice';

import featuresService from '@/services/featuresService';

const getFeaturesVpsFree = () => async dispatch => {
  try {
    const response = await featuresService.getFeatures('free');

    const { data } = response;

    dispatch(setFeaturesVpsFree(data));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetFeaturesVpsFree failure',
    );
  }
};

const getFeaturesVpsPaid = () => async dispatch => {
  try {
    const response = await featuresService.getFeatures('paid');

    const { data } = response;

    dispatch(setFeaturesVpsPaid(data));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetFeaturesVpsPaid failure',
    );
  }
};

const getFeaturesMonitoring = () => async dispatch => {
  try {
    const response = await featuresService.getFeatures('monitoring');

    const { data } = response;

    dispatch(setFeaturesMonitoring(data));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetFeaturesMonitoring failure',
    );
  }
};

export default {
  getFeaturesVpsFree,
  getFeaturesVpsPaid,
  getFeaturesMonitoring,
};
